import React from 'react';
import { observer } from 'mobx-react';

import { ComponentBase } from '../../../shared/ComponentBase.js';
import { InjectedStyledComponent } from '../../../shared/InjectedStyledComponent.js';
import { AssetContext } from '../Asset/Asset.js';
import { IAssetContextValue } from '../Asset/models/IAssetContextValue.js';
import Image from '../Image/Image.js';
import VisuallyHidden from '../VisuallyHidden/VisuallyHidden.js';

import { IScaleConfiguration, IScaleProps, IScaleState } from './models/index.js';
import Item from './styledComponents/Item.js';
import Placeholder from './styledComponents/Placeholder.js';
import Wrapper from './styledComponents/Wrapper.js';
import { SCALE_CATEGORY_KEY, SCALE_COMPONENT_KEY } from './Scale.meta.js';

export class Scale extends ComponentBase<IScaleProps, IScaleState, IScaleConfiguration> {
	categoryKey = SCALE_CATEGORY_KEY;
	componentKey = SCALE_COMPONENT_KEY;

	constructor(props: IScaleProps) {
		super(props);
	}
	render() {
		const { className, value = 0, max = 4, placeholder } = this.props;
		const collection: boolean[] = [];
		for (let i = 1; i <= max; i++) {
			collection.push(value >= i);
		}
		if (placeholder && !value) {
			return <Placeholder>{placeholder}</Placeholder>;
		}
		return (
			<AssetContext.Consumer>
				{(assetContext: IAssetContextValue) => (
					<Wrapper className={className}>
						{collection.map((selected, index) => {
							let asset = 'base.scale.empty';
							if (selected) {
								asset = 'base.scale.filledDefault';
								const assets = assetContext.assets;
								if (assets && assets.base && assets.base.scale && assets.base.scale.overrides) {
									const overrideIndex = assets.base.scale.overrides.findIndex(
										(override) => override.asset && override.value === value,
									);
									if (overrideIndex !== -1 && typeof overrideIndex === 'number') {
										asset = `base.scale.overrides[${overrideIndex}].asset`;
									}
								}
							}
							return (
								<Item key={index} aria-hidden={true}>
									<Image asset={asset} />
								</Item>
							);
						})}
						<VisuallyHidden>{value}</VisuallyHidden>
					</Wrapper>
				)}
			</AssetContext.Consumer>
		);
	}
}

export default InjectedStyledComponent(observer(Scale), SCALE_CATEGORY_KEY, SCALE_COMPONENT_KEY);
